"use client";

import { useEffect, useRef, useCallback } from "react";
import { useAccordionContext } from "./context";
import styles from "./index.module.scss";

export default function ItemContent({
  children,
  className,
  id,
  nonAnimated = false,
}) {
  const itemRef = useRef(null);
  const contentRef = useRef(null);
  const { activeItem } = useAccordionContext();

  const handleToggle = useCallback(() => {
    if (!contentRef?.current || !itemRef?.current) return;

    if (nonAnimated) {
      itemRef.current.style.height = "auto";
      itemRef.current.style.display = activeItem === id ? "block" : "none";
    } else {
      itemRef.current.style.height =
        activeItem === id ? `${contentRef.current.scrollHeight + 12}px` : "0px";
    }
  }, [contentRef, activeItem, id, nonAnimated]);

  useEffect(() => {
    handleToggle();
  }, [handleToggle]);

  return (
    <div ref={itemRef} className={`${styles.content}`}>
      <div ref={contentRef} className={`${className} text-sm bg-card-foreground rounded-md px-6 py-3 lg:mx-6 lg:px-8`}>
        {children}
      </div>
    </div>
  );
}
